Object.defineProperty(exports,"__esModule",{value:true});var globalState={
renderingObserverDepth:0,
accessStateStrictMode:false};


var incrementRenderingObserverDepth=exports.incrementRenderingObserverDepth=function incrementRenderingObserverDepth(){return globalState.renderingObserverDepth++;};

var decrementRenderingObserverDepth=exports.decrementRenderingObserverDepth=function decrementRenderingObserverDepth(){return globalState.renderingObserverDepth--;};

var isRenderingObserver=exports.isRenderingObserver=function isRenderingObserver(){return globalState.renderingObserverDepth>0;};

var setAccessStateStrictMode=exports.setAccessStateStrictMode=function setAccessStateStrictMode(shouldCheck){
globalState.accessStateStrictMode=Boolean(shouldCheck);
};

var isAccessStateStrictMode=exports.isAccessStateStrictMode=function isAccessStateStrictMode(){return globalState.accessStateStrictMode;};